<template>
    <!-- 下拉框二次封装
        @author: liuguisheng
        @date: 2019-9-13
    -->
  <preview-form-item v-if="isDisplay && showRule!=='render'"
                     :labelText="labelName"
                     :labelWidth="labelWidth"
                     :labelPosition="labelPosition"
                     :textAlign="labelTextPosition"
                     :formType="formType"
                     :variableName="model"
                     :rules="validatorRule"
                     :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-select v-model="selectModel" 
                 :placeholder="placeholder"
                 :multiple="isMultiple"
                 :clearable="isClearable"
                 :disabled="isDisabled"
                 :style="{ width }">
        <el-option v-for="(item,i) in options"
                   :key="i"
                   :label="item.value"
                   :value="item.label">
        </el-option>
      </el-select>
    </div>         
  </preview-form-item>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";


export default {
  mixins: [ mixPreviewItemTemplateChild ],
  computed: {
    /** @name 下拉选择器选择的值
     *  @return {Any} 选择器选择的值
     *  @author 王汝鹏
     *  @version 2019-12-28
     */
    selectModel: {
      get() { return this.currentModel; },
      set(newValue) { this.currentModel = Array.isArray(newValue) ? this.optionValues.filter(value => newValue.includes(value)) : newValue; }
    },
    /** @name 选择项值数组
     *  @return {Array<String>} 选项值数组
     *  @author 王汝鹏
     *  @version 2019-12-28
     */
    optionValues() { return this.options.map(option => option.label); }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemSelect.vue